export default "__VITE_ASSET__CUsYiZEr__"